@if (seasonalLeases) {
  <table class="adminTable">
    <thead>
      <tr>
        <th>ID</th>
        <th class="text-left">Listing Name</th>
        <th class="text-left">Name</th>
        <th>Status</th>
        <!-- <th>Display Label</th> -->
        <th>Start (UTC)</th>
        <th>End (UTC)</th>
        <th>Landowner Amount</th>
        <th>OA Amount</th>
        <th>Member Fee</th>
        <th class="max-participant-col">Max # Participants</th>
        <th class="text-left" title="Long Description">Description</th>
      </tr>
    </thead>
    <tbody>
      @for (seasonalRental of seasonalLeases; track seasonalRental) {
        <tr>
          <td>{{ seasonalRental.id }}</td>
          <td class="text-left">
            {{ seasonalRental.title }}
            <link-to-new-admin-listing [listingId]="seasonalRental.listingId"> </link-to-new-admin-listing>
          </td>
          <td class="text-left">{{ seasonalRental.name }}</td>
          <td>
            @if (showReservationMessage(seasonalRental)) {
              <div>
                <span class="reserve-text"> RESERVED </span>
              </div>
            }
          </td>
          <!-- <td>{{ seasonalRental.label }}</td> -->
          <td>
            <div>
              {{ seasonalRental.startDateTime | date: "yyyy-MM-dd" }}
            </div>
            <div>
              {{ seasonalRental.startDateTime | date: "HH:mm" }}
            </div>
          </td>
          <td>
            <div>
              {{ seasonalRental.endDateTime | date: "yyyy-MM-dd" }}
            </div>
            <div>
              {{ seasonalRental.endDateTime | date: "HH:mm" }}
            </div>
          </td>
          <td>
            <!-- Seasonal Lease - Lease Cost Amount -->
            <span>{{ seasonalRental.initialCost | currency: "USD":"symbol":"1.0-0" }}</span>
          </td>
          <td>
            <!-- Seasonal Lease - OA Amount -->
            <span>{{ seasonalRental.oaAmount | currency: "USD":"symbol":"1.0-0" }}</span>
          </td>
          <td>
            <!-- Membership Fee Amount -->
            <span>{{ seasonalRental.membershipAmount | currency: "USD":"symbol":"1.0-0" }}</span>
          </td>
          <td>{{ seasonalRental.maximumMemberCount }}</td>
          <!-- <td>
          <a
            *ngIf="seasonalRental && seasonalRental.reservationId"
            title="Click to view reservation"
            target="_blank"
            [routerLink]="['/admin/reservation', seasonalRental.reservationId]"
            >
            {{ seasonalRental.reservationId }}
          </a>
          <link-to-booking-detail [bookingId]="seasonalRental.bookingId"> </link-to-booking-detail>
        </td>
        <td>{{ seasonalRental.biddingEnabled }}</td>
        <td>
          <div class="description-text">
            {{ seasonalRental.shortDescription }}
          </div>
        </td> -->
        <td>
          <div class="description-text">
            {{ seasonalRental.description }}
          </div>
        </td>
      </tr>
    }
  </tbody>
</table>
}

@if (loading) {
  <spinner messageRelativePosition="bottom"> </spinner>
}
